import { render, staticRenderFns } from "./work-station.vue?vue&type=template&id=90fb46a2&scoped=true"
import script from "./work-station.vue?vue&type=script&lang=js"
export * from "./work-station.vue?vue&type=script&lang=js"
import style0 from "./work-station.vue?vue&type=style&index=0&id=90fb46a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb46a2",
  null
  
)

export default component.exports